import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../pages/admin/Admin.css'; // import css admin

const API_BASE = 'https://doticom.vn:5000/api/DieuChuyenKho/store/';
const API_CONFIRM = 'https://doticom.vn:5000/api/DieuChuyenKho/batch/xac-nhan';

function formatDate(date) {
  return date.toISOString().slice(0, 10);
}

const ConfirmDieuChuyen = () => {
  const [data, setData] = useState([]);
  const [date, setDate] = useState(formatDate(new Date()));
  const [loading, setLoading] = useState(false);
  const [soLuongXacNhan, setSoLuongXacNhan] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const maCH = localStorage.getItem('IDCH') || '47';

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(
        `${API_BASE}${maCH}?TuNgay=${date}&DenNgay=${date}`
      );
      setData(res.data.data || []);
    } catch (e) {
      setError('Lỗi tải dữ liệu');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [date]);

  const handleInputChange = (id, value) => {
    setSoLuongXacNhan({
      ...soLuongXacNhan,
      [id]: value,
    });
  };

  const handleConfirm = async () => {
    setError('');
    setSuccess('');
    // Lấy các phiếu direction=2 chưa xác nhận
    const items = Object.entries(soLuongXacNhan)
      .filter(([id, val]) => val !== '' && !isNaN(val))
      .map(([id, val]) => {
        const item = data.find(d => d.id === Number(id));
        return {
          id: Number(id),
          soLuongXacNhan: Number(val),
          maSP: item?.maSP || '', 
        };
      });
    if (items.length === 0) {
      setError('Vui lòng nhập số lượng xác nhận');
      return;
    }
    try {
      await axios.patch(API_CONFIRM, {
        items,
        nguoiXacNhan: localStorage.getItem('email') || 'admin@company.com',
        ngayXacNhan: date,
      });
      setSuccess('Xác nhận thành công');
      fetchData();
    } catch (e) {
      setError('Lỗi xác nhận');
    }
  };

  const today = formatDate(new Date());

  return (
    <div className="dieu-chuyen-container" style={{ width: "100%" }}>
      <div className="section-header">
        <h2>Xác nhận điều chuyển</h2>
        <p>Xác nhận số lượng điều chuyển thực nhận</p>
      </div>
      <div className="card mb-3">
        <div className="card-header">
          <label htmlFor="date">Chọn ngày:</label>
          <input
            id="date"
            type="date"
            className="form-control form-control-sm me-2"
            value={date}
            onChange={e => setDate(e.target.value)}
            style={{ maxWidth: 180, display: 'inline-block' }}
          />
          <button className="btn btn-outline-primary btn-sm" onClick={fetchData}>Tải lại</button>
        </div>
        <div className="card-body">
          {loading && <div className="spinner-border text-primary" />}
          {error && <div className="text-danger mb-2">{error}</div>}
          {success && <div className="text-success mb-2">{success}</div>}
          <div className="table-responsive">
            <table className="table table-striped table-bordered" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Mã SP</th>
                  <th>Tên SP</th>
                  <th>ĐVT</th>
                  <th>Đơn giá</th>
                  <th>Người tạo</th>
                  <th>Ngày điều chuyển</th>
                  <th>Số lượng điều chuyển</th>
                  <th>Số lượng xác nhận</th>
                  <th>Xác nhận</th>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter(item => item.direction === 2)
                  .map(item => {
                    const isToday =
                      item.ngayDieuChuyen &&
                      item.ngayDieuChuyen.slice(0, 10) === today;
                    return (
                      <tr
                        key={item.id}
                        style={{
                          background: isToday ? '#ffeeba' : '',
                          opacity: item.daxacnhan ? 0.6 : 1,
                        }}
                      >
                        <td>{item.maSP}</td>
                        <td>{item.ten_SP}</td>
                        <td>{item.dvT_SP}</td>
                        <td>{item.donGia}</td>
                        <td>{item.tenUser}</td>
                        <td>{item.ngayDieuChuyen.slice(0, 10)}</td>
                        <td>{item.soLuongDieuChuyen}</td>
                        <td>
                          {!item.daxacnhan ? (
                            <input
                              type="number"
                              min="0"
                              step="any"
                              className="form-control form-control-sm"
                              value={soLuongXacNhan[item.id] || ''}
                              onChange={e =>
                                handleInputChange(item.id, e.target.value)
                              }
                              style={{ width: 80 }}
                            />
                          ) : (
                            item.soLuongXacNhan
                          )}
                        </td>
                        <td>
                          {!item.daxacnhan && (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                setSoLuongXacNhan({
                                  ...soLuongXacNhan,
                                  [item.id]: soLuongXacNhan[item.id] || item.soLuongDieuChuyen,
                                });
                                handleConfirm();
                              }}
                            >
                              Xác nhận
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDieuChuyen;
